import { isWeiXin, isAndroidOrIos } from './index'
export function paying(method, url, return_url) {
  return new Promise((resolve, reject) => {
    if (isWeiXin()) {
        // 在微信浏览器中
        wxJsPay(url, return_url, resolve, reject)
    } else {
        defaultPay(method, url, return_url, resolve, reject)
    }
  })
}

function defaultPay(method, url, return_url, resolve, reject) {
    // 微信支付
    if(method == 1){
      if(isAndroidOrIos() === 'ios'){
        var redirect_url = encodeURIComponent(window.location.host+"://")
        url = url+"&redirect_url="+redirect_url+"&success_url="+return_url
      }else{
        url = url+"&redirect_url="+encodeURIComponent(return_url)
      }
    }
    resolve(url)
}

function wxJsPay(url, return_url, resolve, reject){
    // eslint-disable-next-line no-undef
    WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        JSON.parse(url),
        function(res){
            resolve(return_url)
        }
    );
}
